module.exports = __webpack_public_path__ + "static/media/veladat.aac880e2.png";